/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import TeamTagsEditModel from '../Modals/TeamTagsEditModel'

export default function DataTableData() {
  const AppService = useAppServices()
  const params = useParams()
  const navigate = useNavigate()
  const [categries, setCategries] = useState([])
  const [teamTgs, setTeamTags] = useState([])
  const [loader, setloader] = useState(true)

  const getTeamsTags = async () => {
    const { response } = await AppService.team_tags.get({})
    if (response) {
      setTeamTags(response.data)
      setloader(false)
    } else {
      setloader(false)
    }
  }
  const onLoad = () => {
    getTeamsTags()
  }

  const handleDeleteTeamTag = async (id) => {
    const { response } = await AppService.team_tags.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    handleRefresh: onLoad,
    teamTagsTable: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'description', accessor: 'description' },

        { Header: 'Action', accessor: 'action' },
      ],

      rows: teamTgs?.map((data, index) => ({
        name: data.name,
        description: data.description,

        action: (
          <div className="d-flex">
            <TeamTagsEditModel handleRefresh={onLoad} editData={data} />
            <MDBox>
              <MDButton
                variant="contained"
                color="error"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => handleDeleteTeamTag(data._id)}
              >
                Delete
              </MDButton>
            </MDBox>
          </div>
        ),
      })),
    },
  }
}
